import { queryResource } from '@/api/resource'
import * as T from '@/core/configs/types'
import get from 'lodash/get'

export const ValidOne = 'Active'
export const InvalidOne = 'Disabled'
export const ValidStatus = {
  ValidOne,
  InvalidOne
}
export const ResourceGroup = 'Group'
export const ResourceSingle = 'Single'
export const ResourceTypes = {
  ResourceGroup,
  ResourceSingle
}
export const AllMethod = 'ALL'
export const GetMethod = 'GET'
export const PostMethod = 'POST'
export const PutMethod = 'PUT'
export const DeleteMethod = 'DELETE'
export const HttpMethods = {
  AllMethod,
  GetMethod,
  PostMethod,
  PutMethod,
  DeleteMethod
}

export const Resource = {
  id: {
    type: T.Number,
    label: 'ID',
    key: 'id'
  },
  name: {
    type: T.String,
    label: 'Name',
    key: 'name'
  },
  uri: {
    type: T.String,
    label: 'Uri',
    key: 'uri'
  },
  method: {
    type: T.Enum,
    label: 'Method',
    key: 'method',
    options: Object.values(HttpMethods)
  },
  type: {
    type: T.Enum,
    label: 'Resource Type',
    key: 'type',
    options: Object.values(ResourceTypes)
  },
  description: {
    type: T.String,
    label: 'Description',
    key: 'description'
  },
  categoryId: {
    type: T.String,
    label: 'Parent',
    key: 'parentId'
  },
  createdTime: {
    type: T.Time,
    label: 'Created on',
    key: 'createdTime'
  },
  updatedTime: {
    type: T.Time,
    label: 'Updated on',
    key: 'updatedTime'
  }
}

export const ResourceTableHeaders = [
  { ...Resource.name, width: 200 },
  { ...Resource.uri, width: 200 },
  {
    ...Resource.method,
    type: T.Tag,
    effect: 'plain',
    tagType: 'primary',
    width: 80
  },
  {
    ...Resource.type,
    key: 'typeList',
    type: T.Tag,
    effect: 'plain',
    tagType: 'success',
    width: 80
  },
  { ...Resource.description, type: T.Text, width: 0 },
  {
    type: T.Text,
    label: 'Parent',
    key: 'parent.name',
    width: 0
  },
  { ...Resource.createdTime, width: 100 }
]

export const ResourceSearchForm = Object.fromEntries(
  [
    {
      ...Resource.name,
      key: 'fuzzyName',
      type: T.TextInput,
      example: '',
      default: '',
      value: '',
      validators: [],
      convertor: T.DefaultConvertor
    },
    {
      label: 'Parent Name',
      key: 'parent_id',
      type: T.TextInput,
      example: '订单',
      default: '',
      value: '',
      validators: [],
      convertor: T.DefaultConvertor
    },
    {
      ...Resource.type,
      type: T.Select,
      key: 'typeList',
      example: '',
      default: '',
      multiple: true,
      options: [...Resource.type.options],
      value: [...Resource.type.options],
      validators: [T.RequiredNotEmptyListValidator],
      convertor: T.DefaultConvertor
    },
    {
      ...Resource.uri,
      type: T.TextInput,
      example: '/order',
      default: '',
      value: '',
      validators: [],
      convertor: T.DefaultConvertor
    },
    ...T.PaginationSearchForm
  ].map(one => [one.key, one])
)

export const ResourceForm = Object.fromEntries(
  [
    {
      ...Resource.name,
      type: T.TextInput,
      span: 1,
      example: '查看订单',
      default: '',
      value: '',
      validators: [T.RequiredValidator]
    },
    {
      ...Resource.uri,
      type: T.TextInput,
      span: 1,
      example: '',
      default: '',
      value: '',
      validators: []
    },
    {
      ...Resource.method,
      span: 1,
      type: T.Select,
      example: 'Method',
      default: AllMethod,
      value: AllMethod,
      validators: [T.RequiredValidator]
    },
    {
      ...Resource.type,
      span: 1,
      type: T.Select,
      example: '',
      default: ResourceGroup,
      width: 60,
      value: ResourceGroup,
      validators: [T.RequiredValidator]
    },
    {
      ...Resource.description,
      type: T.TextInput,
      span: 1,
      example: '',
      default: '',
      value: '',
      validators: []
    },
    {
      ...Resource.categoryId,
      type: T.RemoteSelect,
      span: 1,
      example: '',
      default: '',
      value: '',
      options: [],
      loading: false,
      method: function (name) {
        const that = this
        this.loading = true
        queryResource({
          fuzzyName: name,
          typeList: [ResourceGroup],
          size: -1
        }).then(res => {
          that.loading = false
          that.options = res.records.map(one => ({
            key: one.id,
            label: one.name,
            value: one.id
          }))
        })
      },
      validators: [T.RequiredValidator]
    }
  ].map(one => [one.key, one])
)

export const InitResourceForm = function (inputs) {
  return Object.keys(ResourceForm).map(key => {
    const one = {
      ...ResourceForm[key],
      value: get(inputs, key, ResourceForm[key].default)
    }
    if (one.key === Resource.categoryId.key && inputs?.parent) {
      one.options = [
        {
          key: inputs.parent.id,
          label: inputs.parent.name,
          value: inputs.parent.id
        }
      ]
    }
    return one
  })
}

export const ResourceSearchParamsWrapUp = searchForm => {
  return T.DefaultWarpSearchForm(searchForm)
}
